export const langList = [
    {
        value: 'zh-CN',
        label: '中文(简体)'
    }, 
    {
        value: 'zh-TW',
        label: '中文(繁体)'
    }, 
    {
        value: 'en',
        label: 'English'
    },
    {
        value: 'ko',
        label: '한국어'
    },
    {
        value: 'ja',
        label: '日本語'
    },
    {
        value: 'de',
        label: 'Deutsch'
    },
    {
        value: 'fr',
        label: 'Français'
    },
    {
        value: 'es',
        label: 'Español'
    },
    {
        value: 'pt',
        label: 'Português'
    },
    {
        value: 'ru',
        label: 'Русский'
    },
    {
        value: 'id',
        label: 'Bahasa Indonesia'
    },
    {
        value: 'it',
        label: 'Italiano'
    },
    {
        value: 'th',
        label: 'ไทย'
    },
    {
        value: 'vi',
        label: 'Tiếng Việt'
    },
    {
        value: 'ar',
        label: 'العربية'
    },
    {
        value: 'tr',
        label: 'Türkçe'
    }
]


// WEBPACK FOOTER //
// ./src/utils/lang.js